import { render } from "./HostAlertWidget.vue?vue&type=template&id=aa6bf404&scoped=true"
import script from "./HostAlertWidget.vue?vue&type=script&lang=js"
export * from "./HostAlertWidget.vue?vue&type=script&lang=js"

import "./HostAlertWidget.vue?vue&type=style&index=0&id=aa6bf404&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa6bf404"]])

export default __exports__